<template>
    <section class="setting">
        <van-tabbar v-model="active" @change="changeTabbar" active-color="#098bef" inactive-color="#9BA5B7">
            <van-tabbar-item name="customer">
                <span>线索</span>
                <template #icon="props">
                    <img :src="props.active ? customerActivedIcon : customerUnactivedIcon" />
                </template>
            </van-tabbar-item>
            
            <van-tabbar-item name="promotion" v-if="token && accountType == 0">
                <span>计划</span>
                <template #icon="props">
                    <img :src="props.active ? promotionActivedIcon : promotionUnactivedIcon" />
                </template>
            </van-tabbar-item>

            <van-tabbar-item name="setting">
                <span>我的</span>
                <template #icon="props">
                    <img :src="props.active ? settingActivedIcon : settingUnactivedIcon" />
                </template>
            </van-tabbar-item>
        </van-tabbar>
        
        <Login :isLoginModel="isLoginModel" :type="type" :topLeftArrow="topLeftArrow" @closeModel="isLoginModel = false"
            @loginStatus="loginStatus" @loginModelFn="loginModelFn" />

        <section class="account_info">
            <img v-if="!token" src="../../assets/img/someone.svg" alt="" class="avatar" @click="isLoginModel=true">
            <img v-if="token" src="../../assets/img/logo.png" alt="" class="avatar" @click="skipByRouterName('account-info')">
            <div class="account">
                <p class="name" @click="skipByRouterName('account-info')">{{account.name || '请先登录'}}</p>
                <p class="org_name">{{account.orgName || ''}}</p>
            </div>
        </section>

        <section class="menu_info" v-if="token && accountType==0">
            <div class="item" @click="skipRecharge">
                <img src="../../assets/img/account_balance_wallet_124dp_D16D6A_FILL0_wght400_GRAD0_opsz48.png" alt="">
                <p>钱包充值</p>
                <span>立即充值</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10" fill="none">
                    <path d="M1 1L4.71429 5L1 9" stroke="#9BA5B7" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
            <div class="item" @click="skipWalletReocrd">
                <img src="../../assets/img/data_table_124dp_D16D6A_FILL0_wght400_GRAD0_opsz48.png" alt="">
                <p>余额记录</p>
                <span>{{account.availableBalance | f_currency}}</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10" fill="none">
                    <path d="M1 1L4.71429 5L1 9" stroke="#9BA5B7" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
        </section>

        <section class="menu_info">
            <div class="item" @click="skipAccountAuth">
                <img src="../../assets/img/id_card_124dp_5985E1_FILL1_wght400_GRAD0_opsz48.png" alt="">
                <p>身份认证</p>
                <span>{{account.authenticationStatus | f_authStatus}}</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10" fill="none">
                    <path d="M1 1L4.71429 5L1 9" stroke="#9BA5B7" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
            <div class="item" @click="skipOrgAuth" v-if="token && accountType==0">
                <img src="../../assets/img/approval_124dp_5985E1_FILL1_wght400_GRAD0_opsz48.png" alt="">
                <p>机构认证</p>
                <span>{{account.orgAuthenticationStatus | f_authStatus}}</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10" fill="none">
                    <path d="M1 1L4.71429 5L1 9" stroke="#9BA5B7" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
        </section>

        <section class="menu_info">
            <div class="item" @click="openRegistration">
                <img src="../../assets/img/help_124dp_48752C_FILL0_wght400_GRAD0_opsz48.png" alt="">
                <p>客服咨询</p>
                <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10" fill="none">
                    <path d="M1 1L4.71429 5L1 9" stroke="#9BA5B7" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
            <div class="item" @click="skipByRouterName('agreement')">
                <img src="../../assets/img/docs_124dp_48752C_FILL0_wght400_GRAD0_opsz48.png" alt="">
                <p>查看协议</p>
                <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10" fill="none">
                    <path d="M1 1L4.71429 5L1 9" stroke="#9BA5B7" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
            <div class="item" @click="skipByRouterName('account-info')">
                <img src="../../assets/img/settings_account_box_124dp_48752C_FILL0_wght400_GRAD0_opsz48.png" alt="">
                <p>账户信息</p>
                <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10" fill="none">
                    <path d="M1 1L4.71429 5L1 9" stroke="#9BA5B7" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
        </section>

        <section class="version_info">
            <p>PRO H5 v{{version}}</p>
            <p v-if="appVersion">App v{{appVersion}}</p>
            <p>鲁ICP备2022033069号-3A</p>
        </section>
    </section>
</template>
  
<script>
import Login from "components/Login";
import settingServer from "api/setting";
import { Toast } from 'vant';

import promotionActivedIcon from "assets/img/flowsheet_124dp_098BEF_FILL0_wght400_GRAD0_opsz48.png";
import promotionUnactivedIcon from "assets/img/flowsheet_124dp_D9D9D9_FILL0_wght400_GRAD0_opsz48.png";
import customerActivedIcon from "assets/img/contact_phone_124dp_098BEF_FILL0_wght400_GRAD0_opsz48.png";
import customerUnactivedIcon from "assets/img/contact_phone_124dp_D9D9D9_FILL0_wght400_GRAD0_opsz48.png";
import settingActivedIcon from "assets/img/account_circle_124dp_098BEF_FILL0_wght400_GRAD0_opsz48.png";
import settingUnactivedIcon from "assets/img/account_circle_124dp_D9D9D9_FILL0_wght400_GRAD0_opsz48.png";

export default {
    name: "setting",
    components: {
        Login,
    },
    data() {
        return {
            promotionActivedIcon,
            promotionUnactivedIcon,
            customerActivedIcon,
            customerUnactivedIcon,
            settingActivedIcon,
            settingUnactivedIcon,

            token: "",
            active: 'setting',
            isLoginModel: false,
            topLeftArrow: true,
            type: "login",

            org: {},
            account: {},

            version: this.$store.state.versionData.versionNumber,

            accountType: '',
            
            appVersion: '',
        };
    },

    created() {
        this.token = localStorage.getItem("token");
        this.accountType = localStorage.getItem("accountType");

        if (this.token) {
            this.getAccountInfo();
        } else {
            this.isLoginModel = true;
        }

        if (window.plus) {
            this.appVersion = plus.runtime.version
        }
    },

    mounted() {
        if (this.$store.state.clientType == 2) {
            document.addEventListener("plusready", function () {
                var webview = plus.webview.currentWebview();
                plus.key.addEventListener("backbutton", function () {
                    webview.canBack(function (e) {
                        if (e.canBack) {
                            webview.back();
                        } else {
                            webview.close();
                        }
                    });
                });
            });
        }
    },

    methods: {
        changeTabbar() {
            if (this.active == 'team') {
                this.$router.push({ name: 'team' })
            }

            if (this.active == 'promotion') {
                this.$router.push({ name: 'promotion' })
            }

            if (this.active == 'customer') {
                this.$router.push({ name: 'customer' })
            }

            if (this.active == 'setting') {
                this.$router.push({ name: "setting" });
            }            
        },

        //登录回调
        loginStatus(status) {
            if (status == "ok") {
                this.isLoginModel = false;
                
                this.token = localStorage.getItem("token");
                this.accountType = localStorage.getItem("accountType");
                this.getAccountInfo();
            }
        },

        loginModelFn(type) {
            if (type == "login") {
                this.topLeftArrow = true;
            } else {
                this.topLeftArrow = false;
            }
            this.type = type;
            this.isLoginModel = true;
        },

        getOrgInfo() {
            settingServer.getOrgInfo().then((res) => {
                this.org = res.data
            })
        },

        getAccountInfo() {
            settingServer.getAccountInfo().then((res) => {
                this.account = res.data
            })
        },

        skipOrgAuth() {
            if (!this.token) return this.isLoginModel = true
            if (this.accountType != 0) return Toast('无操作权限')
            
            this.$router.push({ name: "auth-org" , params: {authStatus: this.account.orgAuthenticationStatus} });
        },

        skipAccountAuth() {
            if (!this.token) return this.isLoginModel = true

            this.$router.push({ name: "auth-account" , params: {authStatus: this.account.authenticationStatus} });
        },

        skipRecharge() {
            if (!this.token) return this.isLoginModel = true
            if (this.account.authenticationStatus !=2) return Toast('请先完成账户认证')
            if (this.account.orgAuthenticationStatus !=2) return Toast('请先完成机构认证')
            if (this.account.subscriptionStatus !=1) return Toast('请先完成订阅')
            if (this.accountType != 0) return Toast('无操作权限')
            

            this.$router.push({ name: "recharge" });
        },

        skipWalletReocrd() {
            if (!this.token) return this.isLoginModel = true
            if (this.accountType != 0) return Toast('无操作权限')

            this.$router.push({ name: "wallet-record" });
        },

        skipByRouterName(name) {
            if (name == 'account-info' && !this.token) {
                return this.isLoginModel = true
            }

            this.$router.push({ name: name });
        },

        openRegistration() {
            const registrationUrl = 'https://work.weixin.qq.com/ca/cawcded59657f71c3a';
            
            if(window.plus) {
                // App环境：使用plus API打开外部浏览器
                plus.runtime.openURL(registrationUrl);
            } else {
                // 浏览器环境：使用window.open打开新窗口
                window.open(registrationUrl, '_blank', 'noopener,noreferrer');
            }
        },
    },
};
</script>
  
<style lang="scss">
.setting {
    background-image: url('../../assets/img/setting_bg.png');
    background-size: 100%;
    background-repeat: no-repeat;
    padding-bottom: 83px;

    .top_c {
        width: 100%;
        position: absolute;

        img.bg {
            width: 100%;
        }
    }

    .account_info {
        border-radius: 22px;
        padding: 30px 18px;
        display: flex;
        align-items: center;

        .avatar {
            height: 72px;
            width: 72px;
            border-radius: 36px;
            background-color: #E6EFFD;
            border: 0;
        }

        .account {
            flex: 1;
            margin-left: 12px;

            .name {
                font-size: 20px;
                line-height: 22px;
                color: #303030;
                display: inline-block;
                padding-right: 5px;
                flex: 1;
                text-align: right;
            }

            .role {
                font-size: 14px;
                line-height: 14px;
                color: #4D5B80;
            }

            .org_name {
                font-size: 13px;
                line-height: 2;
                color: rgba(77, 91, 128, 0.70);
            } 
        } 
    }

    .menu_info {
        margin-bottom: 16px;
        background-color: #fff;
        border-radius: 16px;

        .item {
            padding: 16px 18px;
            display: flex;
            align-items: center;
            border-bottom: 1px solid #E6EFFD;
            
            &:last-child {
                border-bottom: none;
            }
            
            img {
                width: 24px;
                height: 24px;
                margin-right: 12px;
            }

            p {
                color: #4D5B80;
                font-size: 14px;
                line-height: 22px;
                flex: 1;
            }

            span {
                color: #9BA5B7;
                font-size: 12px;
                line-height: 22px;
                margin-right: 12px;
            }
        }

    }

    .version_info {
        padding: 20px 0 40px 0;

        p {
            text-align: center;
            color: #8F9CC2;
            font-size: 10px;
            line-height: 22px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/index/Setting.vue